import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ColumnProps } from 'antd/lib/table'
import { TableCP } from 'submodules/nerit-framework-ui/common/components/table/TableCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { FormStateManagerUtils } from 'submodules/nerit-framework-ui/common/form-state-manager/FormStateManagerUtils'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { ParameterControlRequests } from 'submodules/nerit-aquatec-sdk/services/parameter-control/ParameterControlRequests'
import { ParameterGridResponseDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-control/dtos/responses/ParameterGridResponseDTO'
import { ParameterControlFiltersFormModel } from 'modules/collection-performance/components/parameter-control/filters-parameter-control/inner/ParameterControlFiltersFormModel'
import { ModalParameterNoteCP } from 'modules/collection-performance/components/parameter-control/modal-parameter-note/ModalParameterNoteCP'
import { ParameterControlTableUtils } from 'modules/collection-performance/components/parameter-control/table-parameter-control/inner/ParameterControlTableUtils'
import { MonthRangeUtils } from 'modules/collection-performance/utils/MonthRangeUtils'

interface ICPProps {
    reloadData: number
    formStateManager: IFormStateManager<ParameterControlFiltersFormModel>
    onLoading: (isLoading: boolean) => void
}

type SelectedNoteTP = {
    locationCode: number,
    locationName: string,
    fieldCode: number,
    fieldName: string,
    note?: string,
}

/**
 * Grade parametro (linha) x ponto (coluna) do Controle de Parametros (Tela 3.3),
 * para um unico mes. O status e derivado e somente leitura; o usuario so edita a nota.
 */
export function TableParameterControlCP(props: ICPProps): JSX.Element {

    const [tableData, setTableData] = useState<any[]>()
    const [tableColumns, setTableColumns] = useState<Array<ColumnProps<any>>>()

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
    const [selectedNote, setSelectedNote] = useState<SelectedNoteTP>()

    const gridRequest = useRequest<ParameterGridResponseDTO>()
    useEffect(onGridRequestChange, [gridRequest.isAwaiting])
    useEffect(() => props.onLoading(gridRequest.isAwaiting), [gridRequest.isAwaiting])

    useEffect(() => { doSearch() }, [props.reloadData])

    /**
     */
    async function doSearch(): Promise<void> {

        if (!await FormStateManagerUtils.validateRequiredFields(props.formStateManager))
            return

        setTableData(undefined)
        setTableColumns(undefined)

        const formValues = props.formStateManager.getFormValues()!
        gridRequest.runRequest(ParameterControlRequests.grid({
            locationCodes: formValues.locationCodes!,
            fieldCodes: formValues.fieldCodes!,
            year: formValues.year!,
            month: formValues.month!,
        }))
    }

    /**
     */
    function onGridRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(gridRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
            return

        const structure = ParameterControlTableUtils.mountTableStructure(
            gridRequest.responseData!,
            (location, cell) => {
                setSelectedNote({
                    locationCode: location.locationCode,
                    locationName: location.locationName,
                    fieldCode: cell.fieldCode,
                    fieldName: cell.fieldName,
                    note: cell.note,
                })
                setIsModalVisible(true)
            },
        )

        setTableColumns(structure.columns)
        setTableData(structure.data)
    }

    const grid = gridRequest.responseData

    if (!tableData || !tableColumns || !grid)
        return <></>

    return (
        <>
            <MonthHeaderSCP>
                <TextCP text={MonthRangeUtils.getFullMonthLabel(grid.year, grid.month)} strong={true} size={'large'}/>
            </MonthHeaderSCP>

            <TableWrapperSCP>
                <TableCP
                    loading={gridRequest.isAwaiting}
                    data={tableData}
                    columns={tableColumns}
                    bordered={true}
                />
            </TableWrapperSCP>

            {
                !!selectedNote &&
                <ModalParameterNoteCP
                    visible={isModalVisible}
                    locationCode={selectedNote.locationCode}
                    locationName={selectedNote.locationName}
                    fieldCode={selectedNote.fieldCode}
                    fieldName={selectedNote.fieldName}
                    year={grid.year}
                    month={grid.month}
                    note={selectedNote.note}
                    onCancel={() => setIsModalVisible(false)}
                    onSave={() => {
                        setIsModalVisible(false)
                        doSearch()
                    }}
                />
            }
        </>
    )
}

const MonthHeaderSCP = styled.div`
    margin: 10px 20px 0 20px;
`

const TableWrapperSCP = styled.div`

    > div {
        max-height: calc(100vh - 320px);
        overflow: auto;
    }

    .ant-table-wrapper {
        padding: 20px;
    }

    thead {
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .fixedColumn {
        background: #fff !important;
        position: sticky;
        left: 0;
        z-index: 1;
    }
`
